import HeroSection from '@/components/landing/HeroSection';
import ProblemSection from '@/components/landing/ProblemSection';
import SolutionSection from '@/components/landing/SolutionSection';
import AIShowcase from '@/components/landing/AIShowcase';
import Portfolio from '@/components/landing/Portfolio';
import ROICalculator from '@/components/landing/ROICalculator';
import Trust from '@/components/landing/Trust';
import LeadMagnet from '@/components/landing/LeadMagnet';
import BlogPreview from '@/components/landing/BlogPreview';
import CTAFinal from '@/components/landing/CTAFinal';
import Footer from '@/components/Footer';

export default function LandingPage() {
  return (
    <main data-testid="landing-page">
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <AIShowcase />
      <Portfolio />
      <ROICalculator />
      <Trust />
      <LeadMagnet />
      <BlogPreview />
      <CTAFinal />
      <Footer />
    </main>
  );
}
